export enum AnomalyStatus {
  DETECTED = 'DETECTED',
  CLASSIFIED = 'CLASSIFIED',
  UNDER_REVIEW = 'UNDER_REVIEW',
}
